export default __webpack_public_path__ + "static/easylife365_easymeet_logo-aeaf31f8da7c23cdb7b37dfc33cc7e7a.svg";